<template>
  <div class="auth-container">
    <div class="auth-background"></div>
    <div class="auth-content">
      <el-card class="auth-card" shadow="always">
        <div class="auth-header">
          <h1 class="auth-title">创建账号</h1>
          <p class="auth-subtitle">来添加账号啦乖乖</p>
        </div>
        
        <el-form 
          :model="registerForm" 
          :rules="rules" 
          ref="formRef" 
          label-position="top"
          class="auth-form"
        >
          <el-form-item label="用户名" prop="username">
            <el-input 
              v-model="registerForm.username" 
              placeholder="请输入用户名"
              size="large"
              :prefix-icon="User"
            />
          </el-form-item>
          
          <el-form-item label="密码" prop="password">
            <el-input
              v-model="registerForm.password"
              type="password"
              placeholder="请输入密码"
              size="large"
              :prefix-icon="Lock"
              show-password
            />
          </el-form-item>
          
          <el-form-item label="确认密码" prop="confirmPassword">
            <el-input
              v-model="registerForm.confirmPassword"
              type="password"
              placeholder="请再次输入密码"
              size="large"
              :prefix-icon="Lock"
              show-password
            />
          </el-form-item>
          
          <el-form-item>
            <el-button
              type="primary"
              size="large"
              :loading="loading"
              @click="register"
              class="auth-button"
              round
            >
              注 册
            </el-button>
          </el-form-item>
        </el-form>
        
        <div class="auth-footer">
          <span class="auth-text">已有账号？</span>
          <el-button type="text" @click="goLogin" class="auth-link">
            立即登录
          </el-button>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';
import { User, Lock } from '@element-plus/icons-vue';
import axios from 'axios';

const validateConfirmPassword = (rule, value, callback) => {
  if (value !== registerForm.value.password) {
    callback(new Error('两次输入的密码不一致'));
  } else {
    callback();
  }
};

const registerForm = ref({
  username: '',
  password: '',
  confirmPassword: '',
});

const rules = {
  username: [
    { required: true, message: '请输入用户名', trigger: 'blur' },
    { min: 4, max: 16, message: '长度在 4 到 16 个字符', trigger: 'blur' }
  ],
  password: [
    { required: true, message: '请输入密码', trigger: 'blur' },
    { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
  ],
  confirmPassword: [
    { required: true, message: '请确认密码', trigger: 'blur' },
    { validator: validateConfirmPassword, trigger: 'blur' },
  ],
};

const loading = ref(false);
const router = useRouter();

const register = async () => {
  loading.value = true;
  try {
    const response = await axios.post('/api/auth/register', {
      username: registerForm.value.username,
      password: registerForm.value.password,
    });
    
    if (response.data.data.success) {
      ElMessage.success('注册成功');
      router.push({ name: 'login' });
    } else {
      ElMessage.error(response.data.data.message || '注册失败');
    }
  } catch (error) {
    ElMessage.error(error.response?.data?.message || '注册失败，请稍后再试');
  } finally {
    loading.value = false;
  }
};

const goLogin = () => {
  router.push({ name: 'login' });
};
</script>

<style scoped>
/* 使用与登录页面相同的样式，保持一致性 */
.auth-container {
  display: flex;
  min-height: 100vh;
  background-color: #f5f7fa;
}

.auth-background {
  flex: 1;
  background: linear-gradient(135deg, #2575fc 0%, #6a11cb 100%);
  background-size: cover;
}

.auth-content {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 480px;
  padding: 40px;
}

.auth-card {
  width: 100%;
  border: none;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.auth-header {
  text-align: center;
  margin-bottom: 30px;
}

.auth-title {
  font-size: 24px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 8px;
}

.auth-subtitle {
  font-size: 14px;
  color: #909399;
  margin: 0;
}

.auth-form {
  margin-top: 20px;
}

.auth-button {
  width: 100%;
  height: 48px;
  font-size: 16px;
  margin-top: 10px;
}

.auth-footer {
  text-align: center;
  margin-top: 20px;
}

.auth-text {
  color: #606266;
  font-size: 14px;
}

.auth-link {
  color: #606266;
  font-size: 14px;
}

.auth-link:hover {
  color: #409eff;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .auth-container {
    flex-direction: column;
  }
  
  .auth-background {
    display: none;
  }
  
  .auth-content {
    width: 100%;
    padding: 20px;
  }
}
</style>